// extracted by mini-css-extract-plugin
export var layoutContainer = "_8g-0";
export var layoutContainerNoRounding = "_8g-6";
export var layoutContainerOpen = "_8g-5";
export var layoutContainerResizing = "_8g-1";
export var mainContent = "_8g-2";
export var resizeDivider = "_8g-3";
export var slidePanel = "_8g-4";